// Datum "do" se zapínátkem Bez konce (16.9.2026).
//
// Lokality bootcampu jedou celoročně, konec se vyplňuje jen výjimečně. Prázdné
// datum a "ještě jsem ho nevyplnil" vypadají v databázi stejně, takže zapínátko
// drží vlastní stav (bezKonce) a rodič ho posílá vedle hodnoty.

import React from "react";
import { Infinity as Nekonecno } from "lucide-react";

/**
 * Datum do se zapínátkem "Bez konce" (16.9.2026). Lokalita normálně jede
 * pořád, konec se vyplňuje jen když se místo opravdu zavírá. Zapínátko drží
 * vlastní stav, protože prázdné datum a "ještě jsem ho nevyplnil" vypadají
 * v databázi stejně a formulář je musí umět rozlišit.
 */
export default function PoleDatumDo({ hodnota, bezKonce, onZmena, onPrepni }) {
  return (
    <div>
      <div className="flex items-center justify-between gap-2 mb-1">
        <span className="text-sm font-medium text-slate-700">Do</span>
        <button
          type="button"
          role="switch"
          aria-checked={!!bezKonce}
          onClick={() => onPrepni(!bezKonce)}
          className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-1 text-xs font-medium transition ${
            bezKonce ? "border-brand bg-brand-50 text-brand-deep" : "border-slate-200 text-slate-500 hover:border-slate-300"
          }`}
        >
          <span className={`flex h-4 w-7 shrink-0 items-center rounded-full p-0.5 transition-colors ${
            bezKonce ? "justify-end bg-brand" : "justify-start bg-slate-300"
          }`}>
            <span className="h-3 w-3 rounded-full bg-white shadow" />
          </span>
          Bez konce
        </button>
      </div>
      {bezKonce ? (
        <div className="flex h-[46px] items-center gap-2 rounded-xl border border-brand bg-brand-50 px-3 text-[15px] font-medium text-brand-deep">
          <Nekonecno className="h-4 w-4 shrink-0" /> Jede pořád
        </div>
      ) : (
        <input type="date" className="field" value={hodnota || ""} onChange={(e) => onZmena(e.target.value)} />
      )}
      <span className="mt-1 block text-xs text-slate-500">
        {bezKonce ? "Lekce se generují po oknech, lokalita se sama neukončí." : "Poslední den lekcí. Den poté je lokalita ukončená."}
      </span>
    </div>
  );
}

